/// <amd-module name="DirtyDocumentServices/Redux/DirtyDocumentsSaga" />
import { effects } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";
import { BeforePageSwitchServiceName, DirtyDocumentServiceName, IDirtyDocumentService } from "..";
import { DirtyDocumentAction, MetaTypes } from "./DirtyDocumentsActions";

const GLOBAL_DIRTY_DOCUMENTS_ID = "global-dirty-document";
export function* monitorDirtyDocuments() {
    // @ts-expect-error TypeScript 4.2 upgrade
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    // Just need to start this service
    yield effects.call([pageContext, pageContext.getService], BeforePageSwitchServiceName);

    // @ts-expect-error TypeScript 4.2 upgrade
    const dirtyDocumentService: IDirtyDocumentService = (yield effects.call([pageContext, pageContext.getService], DirtyDocumentServiceName)) as any;

    // Maintaining local data instead of store as the callback function is not a generator
    const dirtyDocumentIds: { [documentid: string]: number } = {};

    // Process each action to maintain dirtyDocumentIds
    yield effects.takeEvery(
        (action: DirtyDocumentAction) =>
            action.meta && (!!action.meta[MetaTypes.SET_DOCUMENT_DIRTY] || !!action.meta[MetaTypes.CLEAR_DOCUMENT_DIRTY]),
        (action: DirtyDocumentAction) => {
            // Mark documents as dirty
            if (action.meta[MetaTypes.SET_DOCUMENT_DIRTY]) {
                let ids: string[] = action.meta[MetaTypes.SET_DOCUMENT_DIRTY]!.ids;
                ids.forEach(id => {
                    dirtyDocumentIds[id] = (dirtyDocumentIds[id] || 0) + 1;
                });
            }

            // Clear document dirty flag
            if (action.meta[MetaTypes.CLEAR_DOCUMENT_DIRTY]) {
                let ids: string[] = action.meta[MetaTypes.CLEAR_DOCUMENT_DIRTY]!.ids;
                ids.forEach(id => {
                    const currentCount = dirtyDocumentIds[id] || 0;
                    if (currentCount > 0) {
                        if (currentCount === 1) {
                            delete dirtyDocumentIds[id];
                        } else {
                            dirtyDocumentIds[id] = currentCount - 1;
                        }
                    }
                });
            }
        }
    );

    try {
        dirtyDocumentService.registerHandler(
            () => {
                return Object.keys(dirtyDocumentIds).length > 0;
            },
            GLOBAL_DIRTY_DOCUMENTS_ID,
            GLOBAL_DIRTY_DOCUMENTS_ID
        );
    } catch {
        dirtyDocumentService.unregisterHandler(GLOBAL_DIRTY_DOCUMENTS_ID, GLOBAL_DIRTY_DOCUMENTS_ID);
    }
}
